export default __webpack_public_path__ + "static/media/img6_1.a3f0bcda.jpg";